import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useW2Paths } from './paths';

/** `/e/:token` index → `register` (C-1: default entry matches today's
 * `authMode: 'register'` default), forwarding any query params (C-4). */
export const W2IndexRedirect: React.FC = () => {
  const { search } = useLocation();
  const paths = useW2Paths();
  return <Navigate to={{ pathname: paths.register, search }} replace />;
};
